import { getTopLevelDomain, type CookieManager } from "utils";

export type Geo = {
  country: string;
  continent: string;
  region: string;
};

const geoipService = "https://services.fandom.com/geoip/location";

export const getGeoData = async (cookies: CookieManager): Promise<Geo> => {
  const geoCookie = cookies.get("Geo");
  if (geoCookie) {
    try {
      return JSON.parse(decodeURIComponent(geoCookie));
    } catch (e) {
      console.error("Error parsing Geo cookie", e);

      // delete the cookie if it's invalid
      const domain = getTopLevelDomain();
      cookies.delete("Geo", {
        domain,
        path: "/",
      });
    }
  }

  const response = await fetch(geoipService);
  const {
    country_code: country,
    region,
    continent_code: continent,
  } = await response.json();

  return { country, region, continent };
};

export const setGeoCookieIfNotExists = (
  cookies: CookieManager,
  geo: Geo,
): void => {
  const geoCookie = cookies.get("Geo");
  if (!geoCookie) {
    const domain = getTopLevelDomain();
    cookies.set("Geo", encodeURIComponent(JSON.stringify(geo)), {
      domain,
      path: "/",
      expires: 365,
    });
  }
};
